<template>
  <div>
    <selectors
      prefix="filter"
      :modal="modal"
      :selectKey="selectKey ? selectKey : titleKey"
      v-model="val"
      :titleKey="`filter_${titleKey}`"
      :title="title"
      :params="params"
      @input="input"
    />
  </div>
</template>
<script>
export default {
  props: {
    modal: {
      default: "",
    },
    selectKey: {
      default: null,
    },
    title: {
      default: "",
    },
    titleKey: {
      default: "title",
    },
    params: {
      default: function () {
        return {};
      },
    },
  },
  name: "filter",
  components: {
    selectors: () => import("./Inputs/Selectors"),
  },
  methods: {
    input() {
      let value = [];
      for (let i = 0; i < this.val.length; i++) {
        value.push(this.val[i].id);
      }
      this.$emit("input", value.join("-"));
    },
  },
  data() {
    return {
      val: [],
    };
  },
};
</script>
<style>
</style>
